<script setup lang="ts">
	/**
	 * @author Beka Chkhaidze
	 *
	 * @summary:
	 * This component is used to change route query only,
	 * use route watchers in parent components to re-fetch data
	 */
	import { computed, ref, onBeforeMount, watch } from "vue";
	import { RouteLocationNormalizedLoaded, useRoute } from "vue-router";
	import { updateQuery } from "@/composables/utils/router";
	

	import VPagination from "@hennge/vue3-pagination";
	import "@hennge/vue3-pagination/dist/vue3-pagination.css";

	const props = withDefaults(
		defineProps<{
			total: number;
			perPage?: number;
		}>(),
		{
			perPage: 12,
		}
	);

	const route = useRoute();

	const routePage = ref(Number(route?.query?.page) || 1);

	const totalPages = computed(() => Math.ceil(props.total / props.perPage));
	const startEnd = ref<{ start?: number; end?: number }>({});

	const doCalculation = () => {
		let start = (routePage.value - 1) * props.perPage + 1;
		let end = routePage.value * props.perPage;

		if (end > props.total) end = props.total;

		startEnd.value.start = start;
		startEnd.value.end = end;
	};

	const updateHandler = (page: number) => {
		// update route very last
		setTimeout(() => {
			updateQuery("page", String(page));
			doCalculation();
		}, 200);
	};

	watch(route, (n: RouteLocationNormalizedLoaded) => {
		routePage.value = Number(n.query?.page) || 1;
	});

	onBeforeMount(doCalculation);
</script>

<template>
	<section class="pagination">
		<v-pagination
			v-model="routePage"
			:class="[
				'custom-pagination',
				{ 'custom-pagination--back-disabled': routePage == 1 },
				{ 'custom-pagination--forward-disabled': routePage == totalPages },
			]"
			:pages="totalPages"
			:hideFirstButton="true"
			:hideLastButton="true"
			:rangeSize="1"
			@update:modelValue="updateHandler"
		/>

		<!-- <div class="summary no-wrap" v-if="startEnd">
      {{ $t("results") }} {{ startEnd.start }} - {{ startEnd.end }} {{ $t("of") }}
      {{ total }}
    </div> -->
	</section>
</template>

<style src="./styles/pagination.scss"></style>
